import React from "react";
import { useNavigate } from "react-router-dom";
import { formatDate, SLASH_DATE_FORMAT } from "$utils/date-helpers";

// data: array of InitiativeFollowUpEntity (overdue open follow-ups) with initiativeName attached
const AwaitingActionCard = ({ data }) => {
    const navigate = useNavigate();
    const items = Array.isArray(data) ? data : [];

    if (items.length === 0) {
        return <p className="dashboard-card__empty">No overdue follow-ups. You're all caught up!</p>;
    }

    return (
        <ul className="dashboard-card__list awaiting-action-card">
            {items.map((f) => (
                <li
                    key={f.id}
                    className="awaiting-action-card__row -overdue"
                    onClick={() => navigate(`/initiatives/${f.initiativeId}`)}
                >
                    <div className="awaiting-action-card__commitment">{f.commitmentText}</div>
                    <div className="awaiting-action-card__meta">
                        {f.initiativeName && (
                            <span className="awaiting-action-card__initiative">{f.initiativeName}</span>
                        )}
                        {f.dueDate && (
                            <span className="awaiting-action-card__due">
                                ⚠ Due {formatDate(f.dueDate, SLASH_DATE_FORMAT)}
                            </span>
                        )}
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default AwaitingActionCard;
